import React, { Component } from 'react'
import { BrowserRouter, Route } from 'react-router-dom';
import DataTable from '../../../components/DataTable/DataTable';
import FrontendVenueForm from './FrontendVenueForm';
import TitleHeader from '../../../components/TitleHeader/TitleHeader'

class FrontendVenue extends Component {
    render() {
        const columns = [
            { label: 'หัวข้อ', align: 'left', name: 'name', search_type: 'string' },
        ];

        const api_url = '/master/venue';

        return (
            <BrowserRouter>
                <div>
                    <TitleHeader program_name='สถานที่ ​(Venue)' program_type='Frontend'></TitleHeader>
                    
                    <Route exact path={`${this.props.match.path}/`} component={() => (<DataTable columns={columns} allow_active={true} url={api_url}></DataTable>)} />
                    
                    <Route path={`${this.props.match.path}/create`} component={props => (<FrontendVenueForm {...props} url={api_url}></FrontendVenueForm>)} />
                    <Route path={`${this.props.match.path}/:id/edit`} component={props => (<FrontendVenueForm {...props} url={api_url}></FrontendVenueForm>)} />
                </div>
            </BrowserRouter>
        )
    }
}

export default FrontendVenue
